import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import instance from "../../../../config/Config";


const initialState = {
    data: null,
    loading: false,
    error: null,
    count: null,
    structure: null,

}

export const fetchSalaryStructureList = createAsyncThunk(
    "fetchSalaryStructureList",
    async (body, { rejectWithValue }) => {
        try {
            const response = await instance.get(`crm/payroll/fetch-salary-structure?page=${body.page}&search=${body.search}`);
            return response.data;
        }
        catch (error) {
            return rejectWithValue(error?.response)
        }
    }
)

export const addSalaryStructure = createAsyncThunk(
    "addSalaryStructure",
    async (data, { rejectWithValue }) => {
        try {
            const response = await instance.post(
                "crm/payroll/create-salary-structure",
                data

            );
            return response.data;
        } catch (error) {
            return rejectWithValue(error?.response);
        }
    }
);

export const deleteStructureDetails = createAsyncThunk(
    "deleteStructureDetails",
    async (ss_id) => {
        try {
            const response = await instance.delete(
                `/crm/payroll/delete-salary-structure?ss_id=${ss_id}`
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    }
);



export const SalaryStructureSlice = createSlice({
    name: 'SalaryStructureSlice',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchSalaryStructureList.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(fetchSalaryStructureList.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
            state.count = action.payload.count;
        })
        builder.addCase(fetchSalaryStructureList.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload?.data;
        });

        builder.addCase(addSalaryStructure.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(addSalaryStructure.fulfilled, (state, action) => {
            state.loading = false;
            state.structure = action.payload

        })
        builder.addCase(addSalaryStructure.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload?.data;
        });

        builder.addCase(deleteStructureDetails.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(deleteStructureDetails.fulfilled, (state, action) => {
            state.loading = false;
            state.structure = action.payload;
        })
        builder.addCase(deleteStructureDetails.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload?.data;
        });






    },

})

export default SalaryStructureSlice.reducer;